<div class="preload-wrapper" *ngIf="loading">
    <div class="preload-img">
        <img src="assets/img/Icon-white.png" alt="loader"/>
    </div>
</div>
